// AppUtil.js

// Define a Map to store all translations
const translations = new Map([
    ["en", {
        // General navigation and UI
        "cartifind agent": "Cartifind Agent",
        "product search": "Product Search",
        "chrome extension": "Chrome Extension",
        "my products": "My Products",
        "my orders": "My Orders",
        "sales apps": "Sales channels",
        "sales channels": "Sales channels",
        "commerce channels": "Commerce channels",
        "ads channels": "Ads channels",
        "settings & plan": "Settings & Plan",
        "help center": "Help Center",
        "external app": "External App",

        // Modal and notification text
        "copied to clipboard": "Copied to clipboard",
        "failed to copy": "Failed to copy",
        "redirecting to authentication...": "Redirecting to authentication...",
        "subscribe": "Subscribe",
        "enter an email address to subscribe.": "Enter an email address to subscribe.",
        "subscribed successfully.": "Subscribed successfully.",
        "subscription failed. please try again.": "Subscription failed. Please try again.",
        "enter your email address to receive occasional cartifind updates.": "Enter your email address to receive occasional Cartifind updates.",
        "email address": "Email address",

        // Feature names
        "import by url": "Import by URL",
        "ai optimization": "AI Optimization",
        "bulk product push": "Bulk Product Push",
        "store analytics": "Store Analytics",

        // Merchant operations dashboard
        "product health": "Product health",
        "updated": "Updated",
        "updating": "Updating",
        "using local data": "Using local data",
        "a focused view of product inventory, suppliers, quality, and margin.": "A focused view of product inventory, suppliers, quality, and margin.",
        "product issues": "Product issues",
        "inventory alerts": "Inventory alerts",
        "next step": "Next step",
        "everything looks ready": "Everything looks ready",
        "no urgent product, supplier, inventory, or margin issue found on this page.": "No urgent product, supplier, inventory, or margin issue found on this page.",
        "${count} more item(s) after this.": "${count} more item(s) after this.",
        "recommended actions for product readiness.": "Recommended actions for product readiness.",
        "shopify product not imported": "Shopify product not imported",
        "inventory sync and live supplier checks unlock after this product is imported to shopify.": "Inventory sync and live supplier checks unlock after this product is imported to Shopify.",
        "${count} to review": "${count} to review",
        "ready": "Ready",
        "no action needed": "No action needed",
        "action needed": "Action needed",
        "needs review": "Needs review",
        "review product": "Review product",
        "supplier reliability": "Supplier reliability",
        "refresh reliability": "Refresh reliability",
        "open growth setup": "Open growth setup",
        "check channel": "Check channel",
        "refresh": "Refresh",
        "check live inventory": "Check live inventory",
        "run live check": "Run live check",
        "run live inventory check": "Run live inventory check",
        "supplier stock changed": "Supplier stock changed",
        "live supplier check needed": "Live supplier check needed",
        "fix product details": "Fix product details",
        "supplier cost changed": "Supplier cost changed",
        "margin risk": "Margin risk",
        "margin risk before scaling": "Margin risk before scaling",
        "margin after supplier cost change": "margin after supplier cost change",
        "this product is ready for the normal edit, save, and import workflow.": "This product is ready for the normal edit, save, and import workflow.",
        "${count} more item(s) will show after these are resolved.": "${count} more item(s) will show after these are resolved.",
        "show ${count} more": "Show ${count} more",
        "show less": "Show less",
        "no issues need attention right now.": "No issues need attention right now.",
        "fulfillment review": "Fulfillment review",
        "fulfillment readiness": "Fulfillment readiness",
        "payment, address, supplier stock, quote, and tracking checks are clear.": "Payment, address, supplier stock, quote, and tracking checks are clear.",
        "resolve the issues below before fulfilling this order.": "Resolve the issues below before fulfilling this order.",
        "review the issues below before paying or fulfilling this order.": "Review the issues below before paying or fulfilling this order.",
        "${count} items awaiting fulfillment": "${count} items awaiting fulfillment",
        "payment, address, supplier, quote, and tracking exceptions before fulfillment.": "Payment, address, supplier, quote, and tracking exceptions before fulfillment.",
        "${count} more": "${count} more",
        "no fulfillment issue detected for this order.": "No fulfillment issue detected for this order.",
        "orders needing attention": "Orders needing attention",
        "resolve these order issues before fulfillment.": "Resolve these order issues before fulfillment.",
        "no payment, address, supplier, quote, or tracking issues detected on this page.": "No payment, address, supplier, quote, or tracking issues detected on this page.",
        "${count} blocked": "${count} blocked",
        "${count} need review": "${count} need review",
        "shipping quote missing": "Shipping quote missing",
        "shipping quote changed": "Shipping quote changed",
        "shipping address needs review": "Shipping address needs review",
        "fulfillment ownership needs review": "Fulfillment ownership needs review",
        "${count} order": "${count} order",
        "${count} orders": "${count} orders",
        "${count} more issue types.": "${count} more issue types.",
        "no fulfillment exceptions detected on this page.": "No fulfillment exceptions detected on this page.",
        "${count} important": "${count} important",
        "${count} more orders need review.": "${count} more orders need review.",
        "ok": "OK",
        "operations health": "Operations health",
        "inventory, suppliers, orders, product quality, margin, and store history.": "Inventory, suppliers, orders, product quality, margin, and store history.",
        "push success": "Push success",
        "inventory sync health": "Inventory sync health",
        "orders needing action": "Orders needing action",
        "supplier risk alerts": "Supplier risk alerts",
        "low margin products": "Low margin products",
        "store data coverage": "Store data coverage",
        "store setup": "Store setup",
        "${products} products and ${orders} orders powering recommendations": "${products} products and ${orders} orders powering recommendations",
        "${orders} historical orders used, ${coverage}% order context coverage": "${orders} historical orders used, ${coverage}% order context coverage",
        "${coverage}% tracking coverage, ${repeat} repeat product signals": "${coverage}% tracking coverage, ${repeat} repeat product signals",
        "${paid} paid, ${unpaid} unpaid historical orders": "${paid} paid, ${unpaid} unpaid historical orders",
        "${fulfilled} fulfilled, ${unfulfilled} unfulfilled historical orders": "${fulfilled} fulfilled, ${unfulfilled} unfulfilled historical orders",
        "${recent} orders in last 30 days, latest ${days} days ago": "${recent} orders in last 30 days, latest ${days} days ago",
        "no order history powering recommendations yet": "No order history powering recommendations yet",
        "review stale order history for recommendations": "Review stale order history for recommendations",
        "${coverage}% store setup coverage": "${coverage}% store setup coverage",
        "action queue": "Action queue",
        "showing saved data": "Showing saved data",
        "refreshing store data": "Refreshing store data",
        "store data refreshed": "Store data refreshed",
        "recommendations use the latest store data.": "Recommendations use the latest store data.",
        "products and orders appear first while store data refreshes.": "Products and orders appear first while store data refreshes.",
        "using live store analysis": "Using live store analysis",
        "refreshing store analysis": "Refreshing store analysis",
        "using saved store signals": "Using saved store signals",
        "using current page signals": "Using current page signals",
        "signal types connected": "signal types connected",
        "no trend channel connected": "No trend channel connected",
        "recommendation data ready": "Recommendation data ready",
        "highest product opportunity": "Highest product opportunity",
        "demand, margin, supplier score": "Demand, margin, supplier score",
        "personalized suggestions from product performance, orders, customer demand, visitor behavior, and connected trend signals.": "Personalized suggestions from product performance, orders, customer demand, visitor behavior, and connected trend signals.",
        "${count} open": "${count} open",
        "clear": "Clear",
        "these orders have payment, address, supplier, quote, or tracking items to review before fulfillment.": "These orders have payment, address, supplier, quote, or tracking items to review before fulfillment.",
        "clear means no payment, address, supplier stock, quote, or tracking exception was detected on the orders currently loaded.": "Clear means no payment, address, supplier stock, quote, or tracking exception was detected on the orders currently loaded.",
        "${count} more actions available after these top priorities.": "${count} more actions available after these top priorities.",
        "inventory changes from ${before} to ${after} stock across ${count} variants": "Inventory changes from ${before} to ${after} stock across ${count} variants",
        "supplier cost changed from ${before} to ${after}": "Supplier cost changed from ${before} to ${after}",
        "projected after supplier cost change": "Projected after supplier cost change",
        "margin delta": "Margin delta",
        "variant": "Variant",
        "single variant product": "Single variant product",
        "no urgent action detected.": "No urgent action detected.",
        "recover import": "Recover import",
        "open products": "Open products",
        "open orders": "Open orders",
        "review settings": "Review settings",
        "connect": "Connect",
        "setup guide": "Setup guide",
        "install extension": "Install extension",
        "extension installed": "Extension installed",
        "extension not installed": "Extension not installed",
        "shop connected": "Shop connected",
        "currency set": "Currency set",
        "ship-to country set": "Ship-to country set",
        "shopify location set": "Shopify location set",
        "markets set": "Markets set",
        "shop country set": "Shop country set",
        "cross-border setup": "Cross-border setup",
        "local-market setup": "Local-market setup",
        "configure shopify markets for cross-border fulfillment": "Configure Shopify Markets for cross-border fulfillment",
        "shop missing": "Shop missing",
        "currency missing": "Currency missing",
        "ship-to country missing": "Ship-to country missing",
        "shopify location missing": "Shopify location missing",
        "markets missing": "Markets missing",
        "shop country missing": "Shop country missing",
        "connect the cartifind chrome extension to your cartifind account before importing from supplier sites.": "Connect the Cartifind Chrome Extension to your Cartifind account before importing from supplier sites.",
        "install the cartifind chrome extension to import from temu, shein, 1688, amazon, aliexpress, etsy, alibaba, and another shopify store product page.": "Install the Cartifind Chrome Extension to import from Temu, SHEIN, 1688, Amazon, AliExpress, Etsy, Alibaba, and another Shopify store product page.",
        "finish setup": "Finish setup",
        "setup complete": "Setup complete",
        "every setup step for this goal is done.": "Every setup step for this goal is done.",
        "only unfinished setup steps are shown here.": "Only unfinished setup steps are shown here.",
        "one clear next step, based on what you want to do.": "One clear next step, based on what you want to do.",
        "your goal": "Your goal",
        "hide setup plan": "Hide setup plan",
        "view %count% later setup steps": "View %count% later setup steps",
        "review product defaults": "Review product defaults",
        "confirm how new products will be fulfilled, priced, published, and sold when stock runs out.": "Confirm how new products will be fulfilled, priced, published, and sold when stock runs out.",
        "fulfillment": "Fulfillment",
        "fulfilled by cartifind": "Fulfilled by Cartifind",
        "fulfilled by you": "Fulfilled by you",
        "pricing": "Pricing",
        "cartifind suggested pricing": "Cartifind suggested pricing",
        "custom pricing rules": "Custom pricing rules",
        "use these defaults": "Use these defaults",
        "change defaults": "Change defaults",
        "product defaults confirmed.": "Product defaults confirmed.",
        "after pushing": "After pushing",
        "publish to online store": "Publish to Online Store",
        "keep as draft": "Keep as draft",
        "when sold out": "When sold out",
        "continue selling": "Continue selling",
        "stop selling": "Stop selling",
        "get started with cartifind": "Get started with Cartifind",
        "import a product, review it, and push it to shopify.": "Import a product, review it, and push it to Shopify.",
        "${completed} of ${total} steps complete": "${completed} of ${total} steps complete",
        "what do you want to do first?": "What do you want to do first?",
        "import products": "Import products",
        "fulfill existing orders": "Fulfill existing orders",
        "sync shopify products": "Sync Shopify products",
        "shopify store connected": "Shopify store connected",
        "cartifind is already running inside your shopify admin.": "Cartifind is already running inside your Shopify admin.",
        "choose shipping destination and currency": "Choose shipping destination and currency",
        "your shipping destination and currency are saved.": "Your shipping destination and currency are saved.",
        "set them here before importing products.": "Set them here before importing products.",
        "install and connect cartifind chrome extension": "Install and connect Cartifind Chrome Extension",
        "extension is installed and signed in.": "Extension is installed and signed in.",
        "extension is installed. connect it with your cartifind account.": "Extension is installed. Connect it with your Cartifind account.",
        "required for temu, shein, 1688, amazon, aliexpress, etsy, alibaba, and another shopify store product page.": "Required for Temu, SHEIN, 1688, Amazon, AliExpress, Etsy, Alibaba, and another Shopify store product page.",
        "review existing shopify orders": "Review existing Shopify orders",
        "orders are ready to review in my orders.": "Orders are ready to review in My Orders.",
        "open my orders to check for fulfillable orders.": "Open My Orders to check for fulfillable orders.",
        "fulfill your first order": "Fulfill your first order",
        "open an order and use cartifind to fulfill it through the supplier.": "Open an order and use Cartifind to fulfill it through the supplier.",
        "review products in my products": "Review products in My Products",
        "products are ready to review and sync.": "Products are ready to review and sync.",
        "import or locate a product before syncing supplier data.": "Import or locate a product before syncing supplier data.",
        "sync product inventory": "Sync product inventory",
        "open my products and sync inventory from the product action menu.": "Open My Products and sync inventory from the product action menu.",
        "import your first product": "Import your first product",
        "you have products ready to review.": "You have products ready to review.",
        "start from product search or paste a supplier product url.": "Start from product search or paste a supplier product URL.",
        "push product to shopify": "Push product to Shopify",
        "at least one product has been pushed to shopify.": "At least one product has been pushed to Shopify.",
        "open my products and push your first product to shopify.": "Open My Products and push your first product to Shopify.",
        "this unlocks after the first product is imported.": "This unlocks after the first product is imported.",
        "connect extension": "Connect extension",
        "ship to": "Ship to",
        "select country": "Select country",
        "currency": "Currency",
        "select currency": "Select currency",
        "search products": "Search products",
        "push to shopify": "Push to Shopify",
        "open my orders": "Open My Orders",
        "open my products": "Open My Products",
        "ship to country is updated": "Ship to country is updated",
        "failed to update ship-to country": "Failed to update ship-to country",
        "currency is updated": "Currency is updated",
        "failed to update currency": "Failed to update currency",
        "chrome extension connected": "Chrome Extension connected",
        "extension key copied. install or open the extension to finish connecting.": "Extension key copied. Install or open the extension to finish connecting.",
        "open the extension and paste your key to connect.": "Open the extension and paste your key to connect.",
        "checking": "Checking",
        "logged in": "Logged in",
        "installed": "Installed",
        "not installed": "Not installed",
        "products": "Products",
        "pushed": "pushed",
        "orders": "orders",
        "extension": "extension",
        "recent import issue": "recent import issue",
        "recover": "Recover",
        "run checks": "Run checks",
        "review pricing": "Review pricing",
        "review inventory": "Review inventory",
        "find suppliers": "Find suppliers",
        "fix qa": "Fix QA",
        "healthy": "Healthy",
        "critical": "Critical",
        "review": "Review",

        // Status messages
        "loading": "Loading",
        "please wait": "Please wait",
        "loading, please wait...": "Loading, please wait...",
        "success": "Success",
        "error": "Error",
        "warning": "Warning",
        "pending": "Pending",
        "completed": "Completed",

        // Action buttons
        "save": "Save",
        "cancel": "Cancel",
        "delete": "Delete",
        "edit": "Edit",
        "update": "Update",
        "submit": "Submit",
        "search": "Search",
        "import": "Import",
        "export": "Export",
        "view details": "View Details",
        "apply": "Apply",
        "get started": "Get Started",

        // US Tariff Modal
        "us order fulfillment tariff update": "US Order Fulfillment Tariff Update",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "Starting Aug 19th, 2025, US fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to US-CHINA tariff. For more about USA tariff, please visit",
        "us customs and border protection.": "US Customs and Border Protection.",
        "eu order fulfillment tariff update": "EU Order Fulfillment Tariff Update",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "EU fulfilled orders will be added a €4 flat tariff charge. For more about EU tariffs, please visit",
        "council of the eu.": "Council of the EU.",
        "for any questions, contact customer support.": "For any questions, contact customer support."
    }],
    ["zh", {
        // General navigation and UI
        "cartifind agent": "Cartifind 代理",
        "product search": "产品搜索",
        "chrome extension": "Chrome 扩展",
        "my products": "我的产品",
        "my orders": "我的订单",
        "settings & plan": "设置和方案",
        "help center": "帮助中心",
        "external app": "外部应用",

        // Modal and notification text
        "copied to clipboard": "已复制到剪贴板",
        "failed to copy": "复制失败",
        "redirecting to authentication...": "正在跳转到认证页面...",
        "subscribe": "订阅",
        "enter an email address to subscribe.": "请输入邮箱地址后再订阅。",
        "subscribed successfully.": "订阅成功。",
        "subscription failed. please try again.": "订阅失败，请重试。",
        "enter your email address to receive occasional cartifind updates.": "输入邮箱地址，接收 Cartifind 的不定期更新。",
        "email address": "邮箱地址",

        // Feature names
        "import by url": "通过URL导入",
        "ai optimization": "AI优化",
        "bulk product push": "批量产品推送",
        "store analytics": "商店分析",

        // Merchant operations dashboard
        "product health": "产品健康度",
        "updated": "已更新",
        "updating": "更新中",
        "using local data": "使用本地数据",
        "a focused view of product inventory, suppliers, quality, and margin.": "聚焦查看产品库存、供应商、质量和利润。",
        "product issues": "产品问题",
        "inventory alerts": "库存提醒",
        "next step": "下一步",
        "everything looks ready": "一切准备就绪",
        "no urgent product, supplier, inventory, or margin issue found on this page.": "当前页面没有紧急的产品、供应商、库存或利润问题。",
        "${count} more item(s) after this.": "完成后还有 ${count} 项。",
        "recommended actions for product readiness.": "产品准备状态的推荐操作。",
        "shopify product not imported": "Shopify 产品尚未导入",
        "inventory sync and live supplier checks unlock after this product is imported to shopify.": "产品导入 Shopify 后会解锁库存同步和实时供应商检查。",
        "${count} to review": "${count} 项待检查",
        "ready": "已就绪",
        "no action needed": "无需操作",
        "action needed": "需要处理",
        "needs review": "待检查",
        "review product": "检查产品",
        "supplier reliability": "供应商可靠性",
        "refresh reliability": "刷新可靠性",
        "open growth setup": "打开增长设置",
        "check channel": "检查渠道",
        "refresh": "刷新",
        "check live inventory": "检查实时库存",
        "run live check": "运行实时检查",
        "run live inventory check": "运行实时库存检查",
        "supplier stock changed": "供应商库存已变化",
        "live supplier check needed": "需要实时供应商检查",
        "fix product details": "修复产品详情",
        "supplier cost changed": "供应商成本已变化",
        "margin risk": "利润风险",
        "margin risk before scaling": "扩量前存在利润风险",
        "margin after supplier cost change": "供应商成本变化后的利润率",
        "this product is ready for the normal edit, save, and import workflow.": "该产品已可正常编辑、保存和导入。",
        "${count} more item(s) will show after these are resolved.": "解决这些后还会显示 ${count} 项。",
        "show ${count} more": "再显示 ${count} 项",
        "show less": "收起",
        "no issues need attention right now.": "目前没有需要处理的问题。",
        "fulfillment review": "履约检查",
        "fulfillment readiness": "履约准备情况",
        "payment, address, supplier stock, quote, and tracking checks are clear.": "付款、地址、供应商库存、报价和追踪检查均无异常。",
        "resolve the issues below before fulfilling this order.": "请先解决以下问题，再履约此订单。",
        "review the issues below before paying or fulfilling this order.": "付款或履约此订单前，请检查以下问题。",
        "${count} items awaiting fulfillment": "${count} 个商品待履约",
        "payment, address, supplier, quote, and tracking exceptions before fulfillment.": "履约前检查付款、地址、供应商、报价和物流追踪异常。",
        "${count} more": "还有 ${count} 项",
        "no fulfillment issue detected for this order.": "该订单未发现履约问题。",
        "orders needing attention": "需要处理的订单",
        "resolve these order issues before fulfillment.": "履约前请先解决这些订单问题。",
        "no payment, address, supplier, quote, or tracking issues detected on this page.": "当前页面未发现付款、地址、供应商、报价或物流追踪问题。",
        "${count} blocked": "${count} 个已阻止",
        "${count} need review": "${count} 个待检查",
        "shipping quote missing": "缺少运费报价",
        "shipping quote changed": "运费报价已变化",
        "shipping address needs review": "收货地址需要检查",
        "fulfillment ownership needs review": "履约归属需要检查",
        "${count} order": "${count} 个订单",
        "${count} orders": "${count} 个订单",
        "${count} more issue types.": "还有 ${count} 类问题。",
        "no fulfillment exceptions detected on this page.": "当前页面未发现履约异常。",
        "${count} important": "${count} 项重要",
        "${count} more orders need review.": "还有 ${count} 个订单需要检查。",
        "ok": "正常",
        "operations health": "运营健康度",
        "inventory, suppliers, orders, product quality, margin, and store history.": "库存、供应商、订单、产品质量、利润和店铺历史数据。",
        "push success": "推送成功率",
        "inventory sync health": "库存同步健康度",
        "orders needing action": "需要处理的订单",
        "supplier risk alerts": "供应商风险提醒",
        "low margin products": "低利润产品",
        "store data coverage": "店铺数据覆盖率",
        "store setup": "店铺设置",
        "${products} products and ${orders} orders powering recommendations": "${products} 个产品和 ${orders} 个订单正在用于推荐",
        "${orders} historical orders used, ${coverage}% order context coverage": "已使用 ${orders} 个历史订单，订单上下文覆盖率 ${coverage}%",
        "${coverage}% tracking coverage, ${repeat} repeat product signals": "物流追踪覆盖率 ${coverage}%，${repeat} 个重复产品信号",
        "${paid} paid, ${unpaid} unpaid historical orders": "${paid} 个已付款，${unpaid} 个未付款历史订单",
        "${fulfilled} fulfilled, ${unfulfilled} unfulfilled historical orders": "${fulfilled} 个已履约，${unfulfilled} 个未履约历史订单",
        "${recent} orders in last 30 days, latest ${days} days ago": "近 30 天 ${recent} 个订单，最近订单 ${days} 天前",
        "no order history powering recommendations yet": "还没有历史订单用于推荐",
        "review stale order history for recommendations": "检查过期订单历史以改进推荐",
        "${coverage}% store setup coverage": "店铺设置覆盖率 ${coverage}%",
        "action queue": "待处理队列",
        "showing saved data": "正在显示已保存数据",
        "refreshing store data": "正在刷新店铺数据",
        "store data refreshed": "店铺数据已刷新",
        "recommendations use the latest store data.": "推荐已使用最新店铺数据。",
        "products and orders appear first while store data refreshes.": "刷新店铺数据时，会先显示已有产品和订单。",
        "using live store analysis": "使用实时店铺分析",
        "refreshing store analysis": "正在刷新店铺分析",
        "using saved store signals": "使用已保存的店铺信号",
        "using current page signals": "使用当前页面信号",
        "signal types connected": "类信号已连接",
        "no trend channel connected": "未连接趋势渠道",
        "recommendation data ready": "推荐数据准备度",
        "highest product opportunity": "最高产品机会分",
        "demand, margin, supplier score": "需求、利润、供应商评分",
        "personalized suggestions from product performance, orders, customer demand, visitor behavior, and connected trend signals.": "基于产品表现、订单、客户需求、访客行为和已连接趋势信号生成个性化建议。",
        "${count} open": "${count} 个待处理",
        "clear": "无待处理",
        "these orders have payment, address, supplier, quote, or tracking items to review before fulfillment.": "这些订单在履约前还有付款、地址、供应商、报价或物流追踪项目需要检查。",
        "clear means no payment, address, supplier stock, quote, or tracking exception was detected on the orders currently loaded.": "无待处理表示当前已加载订单没有检测到付款、地址、供应商库存、报价或物流追踪异常。",
        "${count} more actions available after these top priorities.": "完成这些优先事项后还有 ${count} 个操作。",
        "inventory changes from ${before} to ${after} stock across ${count} variants": "库存将从 ${before} 变为 ${after}，覆盖 ${count} 个变体",
        "supplier cost changed from ${before} to ${after}": "供应商成本从 ${before} 变为 ${after}",
        "projected after supplier cost change": "供应商成本变化后的预计值",
        "margin delta": "利润率变化",
        "variant": "变体",
        "single variant product": "单变体产品",
        "no urgent action detected.": "没有发现紧急操作。",
        "recover import": "恢复导入",
        "open products": "打开产品",
        "open orders": "打开订单",
        "review settings": "检查设置",
        "setup guide": "设置指南",
        "install extension": "安装插件",
        "extension installed": "插件已安装",
        "extension not installed": "插件未安装",
        "shop connected": "店铺已连接",
        "currency set": "币种已设置",
        "ship-to country set": "收货国家已设置",
        "shopify location set": "Shopify Location 已设置",
        "markets set": "Markets 已设置",
        "shop country set": "店铺国家已设置",
        "cross-border setup": "跨境设置",
        "local-market setup": "本地市场设置",
        "configure shopify markets for cross-border fulfillment": "配置 Shopify Markets 以支持跨境履约",
        "shop missing": "店铺未连接",
        "currency missing": "币种缺失",
        "ship-to country missing": "收货国家缺失",
        "shopify location missing": "Shopify Location 缺失",
        "markets missing": "Markets 缺失",
        "shop country missing": "店铺国家缺失",
        "connect the cartifind chrome extension to your cartifind account before importing from supplier sites.": "从供应商网站导入前，请先把 Cartifind Chrome 插件连接到你的 Cartifind 账户。",
        "install the cartifind chrome extension to import from temu, shein, 1688, amazon, aliexpress, etsy, alibaba, and another shopify store product page.": "安装 Cartifind Chrome 插件，以便从 Temu、SHEIN、1688、Amazon、AliExpress、Etsy、Alibaba 和其他 Shopify 店铺商品页导入。",
        "finish setup": "完成设置",
        "setup complete": "设置已完成",
        "every setup step for this goal is done.": "这个目标的设置步骤都已完成。",
        "only unfinished setup steps are shown here.": "这里只显示未完成的设置步骤。",
        "one clear next step, based on what you want to do.": "根据你的目标，一次只显示一个清晰的下一步。",
        "your goal": "你的目标",
        "hide setup plan": "收起设置计划",
        "view %count% later setup steps": "查看后续 %count% 个设置步骤",
        "review product defaults": "检查产品默认设置",
        "confirm how new products will be fulfilled, priced, published, and sold when stock runs out.": "在导入或优化产品前，确认新产品的履约、定价、发布和缺货销售方式。",
        "fulfillment": "履约方式",
        "fulfilled by cartifind": "由 Cartifind 履约",
        "fulfilled by you": "由你履约",
        "pricing": "定价方式",
        "cartifind suggested pricing": "Cartifind 建议定价",
        "custom pricing rules": "自定义定价规则",
        "use these defaults": "使用这些默认设置",
        "change defaults": "更改默认设置",
        "product defaults confirmed.": "产品默认设置已确认。",
        "after pushing": "推送后",
        "publish to online store": "发布到在线商店",
        "keep as draft": "保留为草稿",
        "when sold out": "缺货时",
        "continue selling": "继续销售",
        "stop selling": "停止销售",
        "get started with cartifind": "开始使用 Cartifind",
        "import a product, review it, and push it to shopify.": "导入产品、检查内容，然后推送到 Shopify。",
        "${completed} of ${total} steps complete": "已完成 ${completed}/${total} 步",
        "what do you want to do first?": "你想先完成什么？",
        "import products": "导入产品",
        "fulfill existing orders": "履约现有订单",
        "sync shopify products": "同步 Shopify 产品",
        "shopify store connected": "Shopify 店铺已连接",
        "cartifind is already running inside your shopify admin.": "Cartifind 已经在你的 Shopify Admin 中运行。",
        "choose shipping destination and currency": "选择收货目的地和币种",
        "your shipping destination and currency are saved.": "收货目的地和币种已保存。",
        "set them here before importing products.": "导入产品前先在这里设置。",
        "install and connect cartifind chrome extension": "安装并连接 Cartifind Chrome 插件",
        "extension is installed and signed in.": "插件已安装并登录。",
        "extension is installed. connect it with your cartifind account.": "插件已安装，请连接到你的 Cartifind 账户。",
        "required for temu, shein, 1688, amazon, aliexpress, etsy, alibaba, and another shopify store product page.": "Temu、SHEIN、1688、Amazon、AliExpress、Etsy、Alibaba 和其他 Shopify 店铺商品页需要此插件。",
        "review existing shopify orders": "查看现有 Shopify 订单",
        "orders are ready to review in my orders.": "订单已可在我的订单中查看。",
        "open my orders to check for fulfillable orders.": "打开我的订单，检查可履约订单。",
        "fulfill your first order": "履约第一笔订单",
        "open an order and use cartifind to fulfill it through the supplier.": "打开订单，并通过 Cartifind 从供应商处履约。",
        "review products in my products": "在我的产品中检查产品",
        "products are ready to review and sync.": "产品已可检查并同步。",
        "import or locate a product before syncing supplier data.": "同步供应商数据前，请先导入或找到一个产品。",
        "sync product inventory": "同步产品库存",
        "open my products and sync inventory from the product action menu.": "打开我的产品，并从产品操作菜单同步库存。",
        "import your first product": "导入第一个产品",
        "you have products ready to review.": "已有产品可检查。",
        "start from product search or paste a supplier product url.": "从产品搜索开始，或粘贴供应商产品 URL。",
        "push product to shopify": "推送产品到 Shopify",
        "at least one product has been pushed to shopify.": "至少一个产品已推送到 Shopify。",
        "open my products and push your first product to shopify.": "打开我的产品，并将第一个产品推送到 Shopify。",
        "this unlocks after the first product is imported.": "导入第一个产品后即可使用。",
        "connect extension": "连接插件",
        "ship to": "收货地",
        "select country": "选择国家",
        "currency": "币种",
        "select currency": "选择币种",
        "search products": "搜索产品",
        "push to shopify": "推送到 Shopify",
        "open my orders": "打开我的订单",
        "open my products": "打开我的产品",
        "ship to country is updated": "收货国家已更新",
        "failed to update ship-to country": "收货国家更新失败",
        "currency is updated": "币种已更新",
        "failed to update currency": "币种更新失败",
        "chrome extension connected": "Chrome 插件已连接",
        "extension key copied. install or open the extension to finish connecting.": "插件密钥已复制。安装或打开插件以完成连接。",
        "open the extension and paste your key to connect.": "打开插件并粘贴密钥完成连接。",
        "checking": "检查中",
        "logged in": "已登录",
        "installed": "已安装",
        "not installed": "未安装",
        "products": "产品",
        "pushed": "已推送",
        "orders": "订单",
        "extension": "插件",
        "recent import issue": "最近导入问题",
        "connect": "连接",
        "recover": "恢复",
        "run checks": "运行检查",
        "review pricing": "检查价格",
        "review inventory": "检查库存",
        "find suppliers": "寻找供应商",
        "fix qa": "修复质检",
        "healthy": "健康",
        "critical": "严重",
        "review": "需检查",

        // Status messages
        "loading": "加载中",
        "please wait": "请稍等",
        "loading, please wait...": "加载中，请稍等...",
        "success": "成功",
        "error": "错误",
        "warning": "警告",
        "pending": "待处理",
        "completed": "已完成",

        // Action buttons
        "save": "保存",
        "cancel": "取消",
        "delete": "删除",
        "edit": "编辑",
        "update": "更新",
        "submit": "提交",
        "search": "搜索",
        "import": "导入",
        "export": "导出",
        "view details": "查看详情",
        "apply": "应用",
        "get started": "开始使用",

        // US Tariff Modal
        "us order fulfillment tariff update": "美国订单履行关税更新",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "从2025年8月19日开始，因美中关税，每个美国履行的订单产品将加收$3关税申报处理费和$1.5关税法律费用。有关美国关税的更多信息，请访问",
        "us customs and border protection.": "美国海关和边境保护局。",
        "eu order fulfillment tariff update": "欧盟订单履行关税更新",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "发往欧盟的履约订单将加收 €4 固定关税费用。有关欧盟关税的更多信息，请访问",
        "council of the eu.": "欧盟理事会。",
        "for any questions, contact customer support.": "如有任何问题，请联系客户支持。"
    }],
    ["ar", {
        // General navigation and UI
        "cartifind agent": "وكيل Cartifind",
        "product search": "البحث عن المنتجات",
        "chrome extension": "امتداد Chrome",
        "my products": "منتجاتي",
        "my orders": "طلباتي",
        "settings & plan": "الإعدادات والخطة",
        "help center": "مركز المساعدة",
        "external app": "التطبيق الخارجي",

        // Modal and notification text
        "copied to clipboard": "تم نسخه إلى الحافظة",
        "failed to copy": "فشل النسخ",

        // Feature names
        "import by url": "استيراد عبر الرابط",
        "ai optimization": "تحسين الذكاء الاصطناعي",
        "bulk product push": "دفع المنتجات بالجملة",
        "store analytics": "تحليلات المتجر",

        // Status messages
        "loading": "جاري التحميل",
        "please wait": "يرجى الانتظار",
        "loading, please wait...": "جاري التحميل، يرجى الانتظار...",
        "success": "نجاح",
        "error": "خطأ",
        "warning": "تحذير",
        "pending": "قيد الانتظار",
        "completed": "مكتمل",

        // Action buttons
        "save": "حفظ",
        "cancel": "إلغاء",
        "delete": "حذف",
        "edit": "تعديل",
        "update": "تحديث",
        "submit": "إرسال",
        "search": "بحث",
        "import": "استيراد",
        "export": "تصدير",
        "view details": "عرض التفاصيل",
        "apply": "تطبيق",
        "get started": "ابدأ الآن",

        // US Tariff Modal
        "us order fulfillment tariff update": "تحديث التعريفة الجمركية لتنفيذ الطلبات الأمريكية",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "بدءًا من 19 أغسطس 2025، سيتم إضافة رسوم معالجة الإعلان الجمركي البالغة 3 دولارات ورسوم قانونية جمركية قدرها 1.5 دولار على كل منتج للطلبات الأمريكية المستوفاة بسبب التعريفة الجمركية بين الولايات المتحدة والصين. لمزيد من المعلومات حول التعريفة الأمريكية، يرجى زيارة",
        "us customs and border protection.": "حماية الحدود والجمارك الأمريكية.",
        "eu order fulfillment tariff update": "تحديث التعريفة الجمركية لتنفيذ طلبات الاتحاد الأوروبي",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "ستُضاف رسوم جمركية ثابتة بقيمة 4 يورو إلى الطلبات المستوفاة داخل الاتحاد الأوروبي. لمزيد من المعلومات حول تعريفة الاتحاد الأوروبي، يرجى زيارة",
        "council of the eu.": "مجلس الاتحاد الأوروبي.",
        "for any questions, contact customer support.": "لأي أسئلة، اتصل بدعم العملاء."
    }],
    ["es", {
        // General navigation and UI
        "cartifind agent": "Agente Cartifind",
        "product search": "Búsqueda de Productos",
        "chrome extension": "Extensión de Chrome",
        "my products": "Mis Productos",
        "my orders": "Mis Pedidos",
        "settings & plan": "Configuración y Plan",
        "help center": "Centro de Ayuda",
        "external app": "Aplicación Externa",

        // Modal and notification text
        "copied to clipboard": "Copiado al portapapeles",
        "failed to copy": "Error al copiar",

        // Feature names
        "import by url": "Importar por URL",
        "ai optimization": "Optimización IA",
        "bulk product push": "Carga Masiva de Productos",
        "store analytics": "Análisis de Tienda",

        // Status messages
        "loading": "Cargando",
        "please wait": "Por favor espera",
        "loading, please wait...": "Cargando, por favor espera...",
        "success": "Éxito",
        "error": "Error",
        "warning": "Advertencia",
        "pending": "Pendiente",
        "completed": "Completado",

        // Action buttons
        "save": "Guardar",
        "cancel": "Cancelar",
        "delete": "Eliminar",
        "edit": "Editar",
        "update": "Actualizar",
        "submit": "Enviar",
        "search": "Buscar",
        "import": "Importar",
        "export": "Exportar",
        "view details": "Ver Detalles",
        "apply": "Aplicar",
        "get started": "Comenzar",

        // US Tariff Modal
        "us order fulfillment tariff update": "Actualización de Arancel de Cumplimiento de Pedidos EE.UU.",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "A partir del 19 de agosto de 2025, los pedidos cumplidos en EE.UU. tendrán una tarifa de procesamiento de declaración arancelaria de $3 y un cargo legal arancelario de $1.5 por cada producto debido al arancel EE.UU.-CHINA. Para más información sobre el arancel de EE.UU., visite",
        "us customs and border protection.": "Protección de Aduanas y Fronteras de EE.UU.",
        "eu order fulfillment tariff update": "Actualización de Arancel de Cumplimiento de Pedidos de la UE",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "A los pedidos cumplidos en la UE se les añadirá un arancel fijo de 4 €. Para más información sobre los aranceles de la UE, visite",
        "council of the eu.": "Consejo de la UE.",
        "for any questions, contact customer support.": "Para cualquier pregunta, contacte con el soporte al cliente."
    }],
    ["fr", {
        // General navigation and UI
        "cartifind agent": "Agent Cartifind",
        "product search": "Recherche de Produits",
        "chrome extension": "Extension Chrome",
        "my products": "Mes Produits",
        "my orders": "Mes Commandes",
        "settings & plan": "Paramètres et Plan",
        "help center": "Centre d'Aide",
        "external app": "Application Externe",

        // Modal and notification text
        "copied to clipboard": "Copié dans le presse-papiers",
        "failed to copy": "Échec de la copie",

        // Feature names
        "import by url": "Importer par URL",
        "ai optimization": "Optimisation IA",
        "bulk product push": "Push Produit en Masse",
        "store analytics": "Analytique de Boutique",

        // Status messages
        "loading": "Chargement",
        "please wait": "Veuillez patienter",
        "loading, please wait...": "Chargement, veuillez patienter...",
        "success": "Succès",
        "error": "Erreur",
        "warning": "Avertissement",
        "pending": "En attente",
        "completed": "Terminé",

        // Action buttons
        "save": "Enregistrer",
        "cancel": "Annuler",
        "delete": "Supprimer",
        "edit": "Modifier",
        "update": "Mettre à jour",
        "submit": "Soumettre",
        "search": "Rechercher",
        "import": "Importer",
        "export": "Exporter",
        "view details": "Voir les détails",
        "apply": "Appliquer",
        "get started": "Commencer",

        // US Tariff Modal
        "us order fulfillment tariff update": "Mise à Jour des Droits de Douane pour les Commandes aux États-Unis",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "À partir du 19 août 2025, les commandes exécutées aux États-Unis verront s'ajouter des frais de traitement de déclaration douanière de 3 $ et une charge légale douanière de 1,5 $ pour chaque produit en raison des droits de douane entre les États-Unis et la Chine. Pour en savoir plus sur les droits de douane américains, veuillez visiter",
        "us customs and border protection.": "la Protection des douanes et des frontières des États-Unis.",
        "eu order fulfillment tariff update": "Mise à Jour des Droits de Douane pour les Commandes dans l'UE",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "Les commandes exécutées dans l'UE se verront ajouter des droits de douane forfaitaires de 4 €. Pour en savoir plus sur les droits de douane de l'UE, veuillez visiter",
        "council of the eu.": "le Conseil de l'UE.",
        "for any questions, contact customer support.": "Pour toute question, contactez le service client."
    }],
    ["it", {
        // General navigation and UI
        "cartifind agent": "Agente Cartifind",
        "product search": "Ricerca Prodotti",
        "chrome extension": "Estensione Chrome",
        "my products": "I Miei Prodotti",
        "my orders": "I Miei Ordini",
        "settings & plan": "Impostazioni e Piano",
        "help center": "Centro Assistenza",
        "external app": "App Esterna",

        // Modal and notification text
        "copied to clipboard": "Copiato negli appunti",
        "failed to copy": "Copia fallita",

        // Feature names
        "import by url": "Importa tramite URL",
        "ai optimization": "Ottimizzazione AI",
        "bulk product push": "Caricamento Prodotti in Blocco",
        "store analytics": "Analisi del Negozio",

        // Status messages
        "loading": "Caricamento",
        "please wait": "Attendere prego",
        "loading, please wait...": "Caricamento, attendere prego...",
        "success": "Successo",
        "error": "Errore",
        "warning": "Avviso",
        "pending": "In attesa",
        "completed": "Completato",

        // Action buttons
        "save": "Salva",
        "cancel": "Annulla",
        "delete": "Elimina",
        "edit": "Modifica",
        "update": "Aggiorna",
        "submit": "Invia",
        "search": "Cerca",
        "import": "Importa",
        "export": "Esporta",
        "view details": "Visualizza Dettagli",
        "apply": "Applica",
        "get started": "Inizia",

        // US Tariff Modal
        "us order fulfillment tariff update": "Aggiornamento Dazio per Ordini USA",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "A partire dal 19 agosto 2025, agli ordini evasi negli USA verrà aggiunto un importo di elaborazione della dichiarazione doganale di $3 e un addebito legale doganale di $1,5 per ogni prodotto dovuto al dazio USA-CINA. Per maggiori informazioni sui dazi USA, visitare",
        "us customs and border protection.": "la Protezione Doganale e delle Frontiere USA.",
        "eu order fulfillment tariff update": "Aggiornamento Dazio per Ordini UE",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "Agli ordini evasi nell'UE verrà aggiunto un dazio forfettario di 4 €. Per maggiori informazioni sui dazi UE, visitare",
        "council of the eu.": "il Consiglio dell'UE.",
        "for any questions, contact customer support.": "Per qualsiasi domanda, contattare il supporto clienti."
    }],
    ["de", {
        // General navigation and UI
        "cartifind agent": "Cartifind Agent",
        "product search": "Produktsuche",
        "chrome extension": "Chrome-Erweiterung",
        "my products": "Meine Produkte",
        "my orders": "Meine Bestellungen",
        "settings & plan": "Einstellungen & Plan",
        "help center": "Hilfecenter",
        "external app": "Externe App",

        // Modal and notification text
        "copied to clipboard": "In die Zwischenablage kopiert",
        "failed to copy": "Kopieren fehlgeschlagen",

        // Feature names
        "import by url": "Import per URL",
        "ai optimization": "KI-Optimierung",
        "bulk product push": "Massenprodukt-Push",
        "store analytics": "Shop-Analyse",

        // Status messages
        "loading": "Wird geladen",
        "please wait": "Bitte warten",
        "loading, please wait...": "Wird geladen, bitte warten...",
        "success": "Erfolg",
        "error": "Fehler",
        "warning": "Warnung",
        "pending": "Ausstehend",
        "completed": "Abgeschlossen",

        // Action buttons
        "save": "Speichern",
        "cancel": "Abbrechen",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "update": "Aktualisieren",
        "submit": "Absenden",
        "search": "Suchen",
        "import": "Importieren",
        "export": "Exportieren",
        "view details": "Details anzeigen",
        "apply": "Anwenden",
        "get started": "Jetzt starten",

        // US Tariff Modal
        "us order fulfillment tariff update": "US-Orderfulfillment-Zollaktualisierung",
        "starting aug 19th, 2025, us fulfilled orders will be added $3 tariff declaration processing fee and $1.5 tariff legal charge on each product due to us-china tariff. for more about usa tariff, please visit": "Ab dem 19. August 2025 werden US-erfüllte Bestellungen aufgrund des US-CHINA-Zolls 3 $ Bearbeitungsgebühr für die Zolldeklaration und 1,5 $ gesetzliche Zollgebühr für jedes Produkt hinzugefügt. Weitere Informationen zum USA-Zoll finden Sie beim",
        "us customs and border protection.": "US-Zoll und Grenzschutz.",
        "eu order fulfillment tariff update": "EU-Orderfulfillment-Zollaktualisierung",
        "eu fulfilled orders will be added a €4 flat tariff charge. for more about eu tariffs, please visit": "Für in der EU erfüllte Bestellungen wird eine pauschale Zollgebühr von 4 € hinzugefügt. Weitere Informationen zum EU-Zoll finden Sie beim",
        "council of the eu.": "Rat der EU.",
        "for any questions, contact customer support.": "Bei Fragen wenden Sie sich an den Kundensupport."
    }]
]);

// Get current language, default to English
const getCurrentLanguage = () => {
    const language = localStorage.getItem('language'); // Get language from localStorage
    return language ? language : 'en'; // Default to English
};

// i18 function to return translated content based on current language
export const i18 = (key, values = {}) => {
    const lowerCaseKey = key?.toLowerCase();
    const currentLanguage = getCurrentLanguage(); // Get current language
    const languageTranslations = translations.get(currentLanguage); // Get translations for current language

    let translation = languageTranslations && languageTranslations[lowerCaseKey] ? languageTranslations[lowerCaseKey] : key; // Get translation, or return original key if not found

    // Dynamically replace placeholders
    for (const placeholder in values) {
        const regex = new RegExp(`\\$\\{${placeholder}\\}`, 'g'); // Create regex to match placeholders
        translation = translation.replace(regex, values[placeholder]); // Replace placeholders
    }

    return translation; // Return final translated string
};
